import { Label } from '../ui/label'

interface FormLabelProps extends React.ComponentProps<typeof Label> {
  required?: boolean
}

export function FormLabel({ htmlFor, children, required }: FormLabelProps) {
  return (
    <Label htmlFor={htmlFor} className="mb-1 block text-sm">
      {children}
      {required && <span className="text-red-500 ml-1">*</span>}
    </Label>
  )
}
